import { useParams } from "react-router-dom";
import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { IndicatorDashBoardProvider } from "./components/modals/IndicatorDashBoard.provider";
import { IndicatorDashboard } from "./components/indicator-dashboard";

export default function IndicatorDetailsPage() {
  const { indicatorId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <IndicatorDashBoardProvider indicatorId={indicatorId || ''}>
          <IndicatorDashboard />
        </IndicatorDashBoardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}
